import { Button, Container, Stack, TextField } from "@mui/material";
import React, { useState } from "react";
import { Navigate, redirect } from "react-router";
import { useLoginContext } from "../../context/loginContextProvider";
import Form from "../../components/Form";
import { useAPI } from "../../api/useAPI";

export default function LoginScreen() {
  const [error, setError] = useState<string>();
  const { setLogin, isLoggedIn } = useLoginContext();
  const { checkAuthentication } = useAPI();

  function submitLogin(formData: any): void {
    const { username, password } = formData;

    if (!username || !password) {
      setError("Please enter both username and password.");
      return;
    }
    setError(undefined);
    // Check authentication
    checkAuthentication(username, password)
      .then((isAuthenticated: boolean | undefined) => {
        if (isAuthenticated) {
          setLogin({ username, password });
          redirect("/dashboard");
        } else if (isAuthenticated === false) {
          setError("Incorrect username or password.");
        } else {
          setError("Error communicating with the backend API.");
        }
      })
      .catch((err: any) => {
        console.error("Error during authentication:", err);
        setError("An error occurred during authentication. Please try again.");
      });
  }

  if (isLoggedIn) {
    return <Navigate to="/" replace={true} />;
  }

  return (
    <Container maxWidth="sm" sx={{ mt: 10 }}>
      <Form onSubmit={submitLogin}>
        <Stack direction="column" spacing={5}>
          <h1>Login</h1>

          <TextField
            // defaultValue={"dashboard"}
            error={!!error}
            required
            fullWidth
            label="MongoDB Username"
            variant="standard"
            helperText={error}
            name="username"
          />

          <TextField
            // defaultValue={'4f78-709b'}
            type="password"
            error={!!error}
            required
            fullWidth
            label="MongoDB password"
            variant="standard"
            name="password"
          />

          <Button type="submit" variant="contained">
            Login
          </Button>
        </Stack>
      </Form>
    </Container>
  );
}
